<section class="user-profile" aria-label="User profile">
  <div class="user-profile__avatar" aria-hidden="true">{{ initials }}</div>
  <div>
    <p class="user-profile__name">{{ fullName }}</p>
    <!-- <p class="user-profile__role">{{ role }}</p> -->
  </div>
</section>
